import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import IconInfo from '../../icons/general/IconInfo';
import Tooltip from '../tooltip';

var messages = defineMessages({
    checkboxTooltipIconInfoText: {
        'id': 'boxui.checkboxTooltip.iconInfoText',
        'defaultMessage': 'Info'
    }
});

var CheckboxTooltip = function CheckboxTooltip(_ref) {
    var label = _ref.label,
        tooltip = _ref.tooltip;
    return React.createElement(
        'div',
        { className: 'checkbox-tooltip-wrapper' },
        label,
        React.createElement(
            Tooltip,
            { text: tooltip },
            React.createElement(
                'div',
                { className: 'info-tooltip' },
                React.createElement(IconInfo, {
                    height: 16,
                    width: 16,
                    title: React.createElement(FormattedMessage, messages.checkboxTooltipIconInfoText)
                })
            )
        )
    );
};

CheckboxTooltip.propTypes = {
    label: PropTypes.node.isRequired,
    tooltip: PropTypes.string.isRequired
};
export default CheckboxTooltip;
import PropTypes from 'prop-types';